import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const ChiantiBancaPage = () => {
  const [visibleSections, setVisibleSections] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setVisibleSections(prev => {
        if (prev >= 16) { clearInterval(timer); return prev; }
        return prev + 1;
      });
    }, 250);
    return () => clearInterval(timer);
  }, []);

  const fadeIn = (index) => ({
    opacity: visibleSections >= index ? 1 : 0,
    transform: visibleSections >= index ? 'translateY(0)' : 'translateY(20px)',
    transition: 'all 0.8s cubic-bezier(0.16, 1, 0.3, 1)',
  });

  // Calcoli reali
  const utile2025 = 29300000;
  const richiestaAnno = 30000;
  const richiesta10anni = 300000;
  const percentualeAnno = ((richiestaAnno / utile2025) * 100).toFixed(3);
  const percentuale10anni = ((richiesta10anni / utile2025) * 100).toFixed(2);
  const sociPrevisti = 2500;
  const tessera = 20;
  const spesaMedia = 50;
  const ricaviAnno = sociPrevisti * (tessera + spesaMedia);
  const ricavi10anni = ricaviAnno * 10;
  const roi10anni = ((ricavi10anni / richiesta10anni) * 100).toFixed(0);

  return (
    <main data-testid="chiantibanca-page" className="min-h-screen pt-20 pb-16">
      <div className="max-w-3xl mx-auto px-6">

        {/* Intestazione riservata */}
        <div style={fadeIn(0)} className="text-center mb-12">
          <p className="font-mono text-[10px] uppercase tracking-[0.4em] text-zinc-600 mb-6">
            DOCUMENTO RISERVATO — PROPOSTA DI PARTNERSHIP STRATEGICA
          </p>
          <div className="w-16 h-[1px] bg-[#00FF41]/30 mx-auto mb-8" />
          <p className="text-zinc-400 text-sm mb-2">Alla cortese attenzione di</p>
          <h1 className="text-3xl sm:text-4xl font-black text-white mb-1">
            Dott. Maurizio Farnesi
          </h1>
          <p className="text-[#00FF41] font-mono text-sm">
            Direttore Generale — ChiantiBanca
          </p>
          <p className="text-zinc-500 text-xs mt-2">
            e per conoscenza al Presidente Cristiano Iacopozzi
          </p>
          <p className="text-zinc-600 text-[10px] mt-1 font-mono">
            Sede Legale: Via Giovanni Paolo II, 1 - Fontebecci, 53035 Monteriggioni (SI)
          </p>
        </div>

        {/* La Storia: Andy Bechtolsheim */}
        <div style={fadeIn(1)} className="mb-12">
          <div className="border-l-4 border-[#FFD700] pl-5 mb-6">
            <p className="text-zinc-300 text-sm leading-relaxed italic">
              "Non avevano nemmeno un ufficio. Solo un garage, un motore di ricerca e un'idea.<br/>
              Andy Bechtolsheim stacco un assegno da <span className="text-[#FFD700] font-bold">$100.000</span> intestato a 
              <span className="text-white font-bold"> "Google Inc."</span> — un'azienda che non esisteva ancora."
            </p>
            <p className="text-zinc-500 text-xs mt-3 font-mono">
              — Stanford University, settembre 1998
            </p>
          </div>
          <p className="text-zinc-400 text-sm leading-relaxed">
            Quella mattina, Andy non investi in un prodotto. Investi in una <span className="text-white font-semibold">visione</span>.
            Il resto e storia. Noi non vi chiediamo $100.000 per un'idea in un garage.
            Vi chiediamo <span className="text-[#00FF41] font-bold">lo 0,{percentualeAnno.split('.')[1]}%</span> dei vostri utili per un progetto già operativo.
          </p>
        </div>

        {/* ═══════ BASE LEGALE — ART. 37 TUB ═══════ */}
        <div style={fadeIn(2)} className="mb-12 bg-[#0A0A0A] border border-red-500/20 p-6 sm:p-8">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-red-400 mb-4">
            BASE LEGALE — OBBLIGO DI LEGGE
          </p>
          <p className="text-white font-bold text-sm mb-4">
            Art. 37, comma 1, TUB (D.Lgs. 385/1993) — Credito Cooperativo
          </p>
          <div className="border-l-2 border-red-500/30 pl-4 mb-4">
            <p className="text-zinc-300 text-xs leading-relaxed italic">
              "Le banche di credito cooperativo devono destinare almeno il <span className="text-red-400 font-bold">70% degli utili netti annuali</span> a 
              riserva legale indivisibile [...] Il residuo deve essere destinato a <span className="text-white font-bold">fini di mutualità, beneficenza, 
              e sostegno di attività di interesse comune nel territorio</span> di competenza."
            </p>
          </div>
          <div className="space-y-2 text-xs text-zinc-400">
            <p><span className="text-white font-bold">Art. 2514 c.c.</span> — Obbligo di operativita prevalente a favore di soci e comunità locali.</p>
            <p><span className="text-white font-bold">Art. 35 TUB</span> — Le BCC esercitano il credito <span className="text-red-400">prevalentemente a favore dei soci</span> e nella zona di competenza territoriale.</p>
            <p><span className="text-white font-bold">L. 49/2016</span> (Riforma BCC) — Conferma obbligo di reinvestimento sul territorio e mutualità prevalente.</p>
          </div>
          <div className="mt-4 p-3 bg-red-500/5 border border-red-500/10">
            <p className="text-red-400 text-xs font-mono font-bold">
              Dott. Farnesi, non e una richiesta. E il vostro mandato statutario.
            </p>
            <p className="text-zinc-500 text-[10px] mt-1">
              ChiantiBanca gia destina €1,5M in sponsorizzazioni + €1,8M tramite ChiantiMutua.
              Noi chiediamo di essere parte di quell'investimento.
            </p>
          </div>
        </div>

        {/* ═══════ I NUMERI — BILANCIO 2025 ═══════ */}
        <div style={fadeIn(3)} className="mb-12">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6">
            I VOSTRI NUMERI — BILANCIO 2025
          </p>
          <p className="text-zinc-400 text-sm mb-6 leading-relaxed">
            Comunicato ufficiale ChiantiBanca, 25 marzo 2026. CdA per Assemblea 26 aprile, Leopolda di Firenze.
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6">
            {[
              { value: '€29,4M', label: 'Utile netto 2025', highlight: true },
              { value: '€99,2M', label: 'Utile triennio cumulato' },
              { value: '34.400', label: 'Soci totali' },
              { value: '3.400', label: 'Soci under 35' },
              { value: '€76M', label: 'Destinati under 35' },
              { value: '€4,37 MLD', label: 'Raccolta globale' },
              { value: '€385M', label: 'Nuovi mutui erogati' },
              { value: '23,3%', label: 'CET1 Ratio' },
              { value: '€324,5M', label: 'Patrimonio netto' },
            ].map((stat, i) => (
              <div key={i} className={`p-3 border text-center ${stat.highlight ? 'border-[#00FF41]/40 bg-[#00FF41]/5' : 'border-zinc-800 bg-[#0A0A0A]'}`}>
                <p className={`text-lg sm:text-xl font-black ${stat.highlight ? 'text-[#00FF41]' : 'text-white'}`}>{stat.value}</p>
                <p className="text-zinc-500 text-[10px] mt-1 font-mono">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ═══════ LA PROPOSTA — NUMERI DEVASTANTI ═══════ */}
        <div style={fadeIn(4)} className="mb-12 bg-[#0A0A0A] border border-[#FFD700]/20 p-6 sm:p-8">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#FFD700] mb-6 text-center">
            LA PROPOSTA — 10 ANNI DI PARTNERSHIP
          </p>
          <div className="text-center mb-8">
            <p className="text-4xl sm:text-5xl font-black text-white">€{richiesta10anni.toLocaleString('it-IT')}</p>
            <p className="text-zinc-500 text-sm mt-2">in 10 anni — 2026 / 2036</p>
          </div>
          
          <div className="space-y-3 mb-8">
            {[
              { periodo: 'Anno 1 (2026)', desc: 'Lancio, sede, primi 500 soci', importo: '€30.000' },
              { periodo: 'Anni 2-3 (2027-2028)', desc: 'Crescita, formazione digitale, doposcuola', importo: '€30.000/anno' },
              { periodo: 'Anni 4-7 (2029-2032)', desc: 'Scala regionale, replicabilita', importo: '€30.000/anno' },
              { periodo: 'Anni 8-10 (2033-2036)', desc: 'Impatto pieno, 2.500 soci attivi', importo: '€30.000/anno' },
            ].map((row, i) => (
              <div key={i} className="flex items-center justify-between p-3 border border-zinc-800">
                <div>
                  <p className="text-white text-sm font-bold">{row.periodo}</p>
                  <p className="text-zinc-500 text-xs">{row.desc}</p>
                </div>
                <p className="text-[#00FF41] font-mono font-bold">{row.importo}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ═══════ GRAFICO CONFRONTO VISIVO ═══════ */}
        <div style={fadeIn(5)} className="mb-12">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6">
            CONFRONTO VISIVO — COSA CHIEDIAMO
          </p>
          
          {/* Bar chart */}
          <div className="bg-[#0A0A0A] border border-zinc-800 p-6">
            <div className="space-y-4">
              {/* Utile ChiantiBanca */}
              <div>
                <div className="flex justify-between text-xs mb-1">
                  <span className="text-zinc-400">Utile netto 2025</span>
                  <span className="text-white font-mono font-bold">€29.300.000</span>
                </div>
                <div className="w-full h-8 bg-zinc-900 relative overflow-hidden">
                  <div className="absolute inset-0 bg-[#00FF41]/20" style={{ width: '100%' }} />
                  <div className="absolute inset-0 flex items-center justify-center text-[#00FF41] font-mono text-xs font-bold">100%</div>
                </div>
              </div>

              {/* Nostro impegno annuo */}
              <div>
                <div className="flex justify-between text-xs mb-1">
                  <span className="text-zinc-400">La nostra richiesta annua</span>
                  <span className="text-[#FFD700] font-mono font-bold">€30.000</span>
                </div>
                <div className="w-full h-8 bg-zinc-900 relative overflow-hidden">
                  <div className="absolute top-0 left-0 h-full bg-[#FFD700]/30" style={{ width: `${percentualeAnno}%`, minWidth: '3px' }} />
                  <div className="absolute inset-0 flex items-center pl-3 text-[#FFD700] font-mono text-xs font-bold">{percentualeAnno}%</div>
                </div>
              </div>

              {/* Sponsorizzazioni attuali */}
              <div>
                <div className="flex justify-between text-xs mb-1">
                  <span className="text-zinc-400">Gia spendete in sponsorizzazioni</span>
                  <span className="text-zinc-300 font-mono font-bold">€1.500.000</span>
                </div>
                <div className="w-full h-8 bg-zinc-900 relative overflow-hidden">
                  <div className="absolute top-0 left-0 h-full bg-zinc-600/30" style={{ width: `${((1500000/utile2025)*100).toFixed(1)}%` }} />
                  <div className="absolute inset-0 flex items-center pl-3 text-zinc-400 font-mono text-xs font-bold">{((1500000/utile2025)*100).toFixed(1)}%</div>
                </div>
              </div>

              {/* AI_COVO su sponsorizzazioni */}
              <div>
                <div className="flex justify-between text-xs mb-1">
                  <span className="text-zinc-400">AI_COVO sulle vostre sponsorizzazioni</span>
                  <span className="text-[#FF2D2D] font-mono font-bold">{((richiestaAnno/1500000)*100).toFixed(1)}%</span>
                </div>
                <div className="w-full h-8 bg-zinc-900 relative overflow-hidden">
                  <div className="absolute top-0 left-0 h-full bg-[#FF2D2D]/30" style={{ width: `${((richiestaAnno/1500000)*100).toFixed(1)}%`, minWidth: '3px' }} />
                  <div className="absolute inset-0 flex items-center pl-3 text-[#FF2D2D] font-mono text-xs font-bold">{((richiestaAnno/1500000)*100).toFixed(1)}%</div>
                </div>
              </div>
            </div>

            <div className="mt-6 p-3 border border-[#FFD700]/20 text-center">
              <p className="text-[#FFD700] text-sm font-bold">
                €29.300.000 o €29.270.000 — Dott. Farnesi, che cambia?
              </p>
            </div>
          </div>
        </div>

        {/* ═══════ SIMULAZIONE ROI — PIANO SOSTENIBILITA ═══════ */}
        <div style={fadeIn(6)} className="mb-12 bg-[#0A0A0A] border border-[#00FF41]/20 p-6 sm:p-8">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6 text-center">
            SIMULAZIONE SOSTENIBILITA — PIANO DECENNALE
          </p>

          {/* Calcolo ricavi */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
            <div className="border border-zinc-800 p-4 text-center">
              <p className="text-2xl font-black text-white">{sociPrevisti.toLocaleString('it-IT')}</p>
              <p className="text-zinc-500 text-[10px] font-mono">SOCI OBIETTIVO</p>
            </div>
            <div className="border border-zinc-800 p-4 text-center">
              <p className="text-2xl font-black text-white">€{tessera + spesaMedia}</p>
              <p className="text-zinc-500 text-[10px] font-mono">SPESA MEDIA/SOCIO/ANNO</p>
              <p className="text-zinc-600 text-[9px]">€{tessera} tessera + €{spesaMedia} servizi</p>
            </div>
            <div className="border border-[#00FF41]/30 p-4 text-center bg-[#00FF41]/5">
              <p className="text-2xl font-black text-[#00FF41]">€{ricaviAnno.toLocaleString('it-IT')}</p>
              <p className="text-zinc-500 text-[10px] font-mono">RICAVI ANNUI PREVISTI</p>
            </div>
          </div>

          {/* Tabella anno per anno */}
          <div className="overflow-x-auto mb-6">
            <table className="w-full text-xs font-mono">
              <thead>
                <tr className="border-b border-zinc-700">
                  <th className="text-left py-2 text-zinc-400">Anno</th>
                  <th className="text-right py-2 text-zinc-400">Soci</th>
                  <th className="text-right py-2 text-zinc-400">Ricavi</th>
                  <th className="text-right py-2 text-zinc-400">Costo CB</th>
                  <th className="text-right py-2 text-[#00FF41]">Copertura</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { anno: '2026', soci: 300, ricavi: 300*70, costo: 30000 },
                  { anno: '2027', soci: 600, ricavi: 600*70, costo: 30000 },
                  { anno: '2028', soci: 1000, ricavi: 1000*70, costo: 30000 },
                  { anno: '2029', soci: 1400, ricavi: 1400*70, costo: 30000 },
                  { anno: '2030', soci: 1800, ricavi: 1800*70, costo: 30000 },
                  { anno: '2031', soci: 2100, ricavi: 2100*70, costo: 30000 },
                  { anno: '2032', soci: 2300, ricavi: 2300*70, costo: 30000 },
                  { anno: '2033', soci: 2500, ricavi: 2500*70, costo: 30000 },
                  { anno: '2034', soci: 2500, ricavi: 2500*70, costo: 30000 },
                  { anno: '2035', soci: 2500, ricavi: 2500*70, costo: 30000 },
                ].map((row, i) => {
                  const copertura = ((row.ricavi / row.costo) * 100).toFixed(0);
                  const autosufficiente = row.ricavi >= row.costo;
                  return (
                    <tr key={i} className={`border-b border-zinc-900 ${autosufficiente ? 'bg-[#00FF41]/3' : ''}`}>
                      <td className="py-2 text-white">{row.anno}</td>
                      <td className="py-2 text-right text-zinc-300">{row.soci.toLocaleString('it-IT')}</td>
                      <td className="py-2 text-right text-zinc-300">€{row.ricavi.toLocaleString('it-IT')}</td>
                      <td className="py-2 text-right text-[#FFD700]">€{row.costo.toLocaleString('it-IT')}</td>
                      <td className={`py-2 text-right font-bold ${autosufficiente ? 'text-[#00FF41]' : 'text-zinc-500'}`}>
                        {copertura}% {autosufficiente ? '>' : ''}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr className="border-t-2 border-[#00FF41]/30">
                  <td className="py-2 text-[#00FF41] font-bold">TOTALE</td>
                  <td className="py-2 text-right text-white font-bold">—</td>
                  <td className="py-2 text-right text-[#00FF41] font-bold">€{ricavi10anni.toLocaleString('it-IT')}</td>
                  <td className="py-2 text-right text-[#FFD700] font-bold">€{richiesta10anni.toLocaleString('it-IT')}</td>
                  <td className="py-2 text-right text-[#00FF41] font-bold">{roi10anni}%</td>
                </tr>
              </tfoot>
            </table>
          </div>

          {/* Highlight autosufficienza */}
          <div className="p-4 border border-[#00FF41]/30 bg-[#00FF41]/5 text-center">
            <p className="text-[#00FF41] font-bold text-sm mb-1">
              Dal 2028 (anno 3): il progetto si autofinanzia.
            </p>
            <p className="text-zinc-400 text-xs">
              Con 1.000 soci x €70 = €70.000 di ricavi vs €30.000 di costo ChiantiBanca.
              <br/>In 10 anni generiamo <span className="text-white font-bold">€{ricavi10anni.toLocaleString('it-IT')}</span> contro 
              <span className="text-[#FFD700] font-bold"> €{richiesta10anni.toLocaleString('it-IT')}</span> richiesti = <span className="text-[#00FF41] font-bold">ROI {roi10anni}%</span>
            </p>
          </div>
        </div>

        {/* ═══════ 4 NUMERI CHE CONTANO ═══════ */}
        <div style={fadeIn(7)} className="mb-12">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6">
            I 4 NUMERI CHE CONTANO
          </p>
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-[#0A0A0A] border border-zinc-800 p-5 text-center">
              <p className="text-3xl sm:text-4xl font-black text-[#FFD700]">{percentualeAnno}%</p>
              <p className="text-zinc-500 text-[10px] font-mono mt-2">DEI VOSTRI UTILI 2025</p>
              <p className="text-zinc-600 text-[9px]">€30.000 su €29.300.000</p>
            </div>
            <div className="bg-[#0A0A0A] border border-zinc-800 p-5 text-center">
              <p className="text-3xl sm:text-4xl font-black text-[#FF2D2D]">{((richiestaAnno/1500000)*100).toFixed(1)}%</p>
              <p className="text-zinc-500 text-[10px] font-mono mt-2">DELLE SPONSORIZZAZIONI</p>
              <p className="text-zinc-600 text-[9px]">€30.000 su €1.500.000 gia destinati</p>
            </div>
            <div className="bg-[#0A0A0A] border border-zinc-800 p-5 text-center">
              <p className="text-3xl sm:text-4xl font-black text-[#00FF41]">{roi10anni}%</p>
              <p className="text-zinc-500 text-[10px] font-mono mt-2">ROI SOCIALE IN 10 ANNI</p>
              <p className="text-zinc-600 text-[9px]">€{ricavi10anni.toLocaleString('it-IT')} generati vs €{richiesta10anni.toLocaleString('it-IT')}</p>
            </div>
            <div className="bg-[#0A0A0A] border border-zinc-800 p-5 text-center">
              <p className="text-3xl sm:text-4xl font-black text-white">100%</p>
              <p className="text-zinc-500 text-[10px] font-mono mt-2">DEDUCIBILITA FISCALE</p>
              <p className="text-zinc-600 text-[9px]">Art. 83 D.Lgs. 117/2017 (ETS)</p>
            </div>
          </div>
        </div>

        {/* ═══════ PERCHE AI_COVO ═══════ */}
        <div style={fadeIn(8)} className="mb-12">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6">
            PERCHE AI_COVO E IL VOSTRO PROGETTO PERFETTO
          </p>
          <div className="space-y-4">
            {[
              { 
                title: '3.400 soci under 35 in ChiantiBanca',
                desc: 'AI_COVO forma esattamente quella fascia. Doposcuola digitale, stage retribuiti, percorsi AI. I vostri soci di domani li stiamo educando noi oggi.',
                stat: '+1.500 under35 nel 2024'
              },
              { 
                title: '€76M destinati agli under 35',
                desc: 'ChiantiBanca investe gia massicciamente nei giovani. AI_COVO e il complemento naturale: non solo mutui, ma competenze digitali per usarli.',
                stat: 'Formazione 2025-2035'
              },
              { 
                title: 'Inclusione e territorio',
                desc: 'SPID, identità digitale, Google per anziani, doposcuola sportivo. Portiamo digitale dove manca — esattamente la mission di una BCC.',
                stat: 'Art. 35 TUB'
              },
              { 
                title: 'Deducibilità fiscale 100%',
                desc: 'Come ente del Terzo Settore (ETS), ogni euro donato/sponsorizzato è interamente deducibile dal reddito d\'impresa.',
                stat: 'Art. 83 D.Lgs. 117/2017'
              },
              {
                title: '2.500 ambasciatori del brand ChiantiBanca',
                desc: 'Logo su ogni T-shirt, ogni attestato, ogni evento. Ogni socio AI_COVO diventa un promotore della vostra banca nel territorio.',
                stat: '2.500 soci obiettivo'
              },
            ].map((item, i) => (
              <div key={i} className="border border-zinc-800 p-4 hover:border-[#00FF41]/30 transition-colors">
                <div className="flex justify-between items-start mb-2">
                  <p className="text-white font-bold text-sm">{item.title}</p>
                  <span className="text-[#00FF41] text-[10px] font-mono whitespace-nowrap ml-3">{item.stat}</span>
                </div>
                <p className="text-zinc-400 text-xs leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Le loro stesse parole */}
        <div style={fadeIn(9)} className="mb-12 bg-[#0A0A0A] border border-zinc-800 p-6 sm:p-8 text-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-6">
            LE VOSTRE STESSE PAROLE
          </p>
          <p className="text-xl sm:text-2xl text-white font-bold leading-relaxed mb-4">
            "L'efficienza di bilancio si può sposare al meglio col 
            <span className="text-[#00FF41]"> sostegno continuo e costante </span>
            a chi ci da fiducia"
          </p>
          <p className="text-zinc-500 text-sm">
            Dott. Farnesi, noi non vi chiediamo fiducia cieca.<br />
            Vi chiediamo di guardare cosa abbiamo costruito.
          </p>
        </div>

        {/* Cosa ottiene ChiantiBanca */}
        <div style={fadeIn(10)} className="mb-12">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6">
            COSA OTTIENE CHIANTIBANCA
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {[
              'Logo su tutte le T-shirt e merchandising',
              'Logo e mention su piattaforma web',
              'Naming partner formazione digitale',
              'Reportistica trimestrale impatto sociale',
              'Accesso anticipato a eventi e iniziative',
              'Corsia preferenziale SPID + servizi digitali',
              'Case history per bilancio sociale BCC/Iccrea',
              'Visibilita CNN-ticker sponsor in homepage',
              'Co-branding su certificazioni digitali',
              'Articoli stampa locale e comunicati congiunti',
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-2 p-3 border border-zinc-800">
                <span className="text-[#00FF41] font-mono text-xs">+</span>
                <p className="text-zinc-300 text-xs">{item}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ═══════ CONVENZIONE BANCARIA ═══════ */}
        <div style={fadeIn(10.5)} className="mb-12 bg-[#0A0A0A] border border-[#FFD700]/30 p-6 sm:p-8">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#FFD700] mb-6">
            INTEGRAZIONE BANCARIA — IL VALORE AGGIUNTO PER CHIANTIBANCA
          </p>
          <div className="space-y-4">
            <div className="border border-[#FFD700]/20 p-4">
              <p className="text-[#FFD700] font-bold text-sm mb-2">1. Conto Online per ogni Socio AI_COVO</p>
              <p className="text-zinc-400 text-xs leading-relaxed">
                Ogni iscritto ad &lt;/AI_covo.tech&gt;® avra diritto ad una 
                <span className="text-white font-bold"> convenzione dedicata per aprire un conto corrente online ChiantiBanca</span>, 
                sul modello dei conti digitali (es. Alphabet di Fideuram). Un conto agevolato, 
                con condizioni riservate ai soci del progetto — creando un canale diretto tra la banca 
                e una community di <span className="text-[#FFD700] font-bold">2.500 potenziali nuovi correntisti</span>.
              </p>
            </div>
            <div className="border border-[#FFD700]/20 p-4">
              <p className="text-[#FFD700] font-bold text-sm mb-2">2. C/C e IBAN del Covo presso ChiantiBanca</p>
              <p className="text-zinc-400 text-xs leading-relaxed">
                La Cooperativa Sociale &lt;/AI_covo.tech&gt;® aprira il proprio 
                <span className="text-white font-bold"> conto corrente operativo presso ChiantiBanca</span>, 
                collegato al circuito bancario con IBAN dedicato. Tutte le donazioni, le iscrizioni, 
                i pagamenti gateway (Stripe, PayPal, bonifici) transiteranno su questo conto. 
                ChiantiBanca diventa il <span className="text-[#FFD700] font-bold">partner bancario esclusivo</span> del progetto.
              </p>
            </div>
          </div>
          <div className="mt-4 p-3 bg-[#FFD700]/5 border border-[#FFD700]/10 text-center">
            <p className="text-[#FFD700] text-xs font-bold">
              2.500 soci = 2.500 potenziali conti ChiantiBanca. Non e solo sponsorizzazione: e acquisizione clienti.
            </p>
          </div>
        </div>

        {/* Timeline */}
        <div style={fadeIn(11)} className="mb-12">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6">
            TIMELINE PROPOSTA
          </p>
          <div className="space-y-0">
            {[
              { date: 'Aprile 2026', event: 'Incontro conoscitivo con Dott. Farnesi', status: 'next' },
              { date: 'Maggio 2026', event: 'Presentazione formale al CdA', status: '' },
              { date: 'Giugno 2026', event: 'Firma accordo di partnership', status: '' },
              { date: 'Settembre 2026', event: 'Lancio ufficiale con evento co-brandizzato', status: '' },
              { date: 'Dicembre 2026', event: 'Primo report impatto sociale', status: '' },
              { date: '2027-2036', event: 'Rinnovo annuale con metriche crescenti', status: '' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-4 py-3 border-b border-zinc-900">
                <div className={`w-2 h-2 rounded-full flex-shrink-0 ${item.status === 'next' ? 'bg-[#00FF41] animate-pulse' : 'bg-zinc-700'}`} />
                <p className="text-zinc-500 text-xs font-mono w-28 flex-shrink-0">{item.date}</p>
                <p className={`text-sm ${item.status === 'next' ? 'text-[#00FF41] font-bold' : 'text-zinc-400'}`}>{item.event}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Contatti */}
        <div style={fadeIn(12)} className="mb-12 bg-[#0A0A0A] border border-[#00FF41]/20 p-6 sm:p-8 text-center">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4">
            CONTATTI DIRETTI
          </p>
          <p className="text-white text-lg font-bold mb-1">&lt;/AI_COVO.tech&gt;<sup className="text-xs">®</sup></p>
          <p className="text-zinc-400 text-xs mb-4">
            A.I.C.O.A. — Associazione Culturale di Colle Val d'Elsa
          </p>
          <div className="space-y-2 mb-6">
            <a href="https://wa.me/393273839782" target="_blank" rel="noopener noreferrer" 
               className="inline-block text-[#00FF41] text-sm font-mono hover:underline">
              +39 327 383 9782 (WhatsApp)
            </a>
          </div>
          <div className="flex justify-center gap-3 flex-wrap">
            <Link to="/dona" className="font-mono text-xs text-black bg-[#00FF41] px-5 py-2 hover:bg-[#33FF66] transition-colors">
              VEDI SISTEMA DONAZIONI
            </Link>
            <Link to="/formazione" className="font-mono text-xs text-[#00FF41] border border-[#00FF41]/30 px-5 py-2 hover:bg-[#00FF41]/10 transition-colors">
              VEDI FORMAZIONE
            </Link>
            <Link to="/links" className="font-mono text-xs text-white border border-zinc-600 px-5 py-2 hover:bg-zinc-800 transition-colors">
              ROADMAP COMPLETA
            </Link>
          </div>
        </div>

        {/* Chiusura emotiva */}
        <div style={fadeIn(13)} className="mb-12 text-center">
          <div className="w-16 h-[1px] bg-[#00FF41]/30 mx-auto mb-8" />
          <p className="text-zinc-400 text-sm leading-relaxed max-w-lg mx-auto mb-6">
            Dott. Farnesi, Andy Bechtolsheim non ha mai chiesto a Larry e Sergey un business plan dettagliato. 
            Ha guardato il demo, ha capito il potenziale, e ha firmato l'assegno.
          </p>
          <p className="text-white text-lg font-bold mb-2">
            Il nostro demo e <span className="text-[#00FF41]">online, adesso</span>.
          </p>
          <p className="text-zinc-500 text-sm mb-8">
            Tutto il resto dipende da una firma.
          </p>
          <div className="inline-block border border-[#FFD700]/30 px-8 py-4">
            <p className="text-[#FFD700] font-mono text-xs uppercase tracking-wider mb-1">
              "Il momento giusto, il posto giusto, i soldi giusti."
            </p>
            <p className="text-zinc-500 text-[10px]">
              €29.300.000 o €29.270.000 — Dott. Farnesi, che cambia?
            </p>
          </div>
        </div>

        {/* Footer documento */}
        <div style={fadeIn(14)} className="text-center text-zinc-600 text-xs border-t border-zinc-900 pt-6">
          <p>Documento generato il {new Date().toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
          <p className="mt-1">&lt;/AI_COVO.tech&gt;® — Digital Hub Sociale</p>
          <p className="text-zinc-700 mt-1">Colle Val d'Elsa — Toscana — Italia</p>
        </div>

      </div>
    </main>
  );
};

export default ChiantiBancaPage;
